import { Injectable } from '@angular/core';
import { Map } from 'immutable';

import { ConsumedProjectItemEntity } from '../consumed-project-item.entity';
import { ConsumedProjectListEntity } from '../consumed-project-list.entity';

@Injectable()
export class ConsumedProjectListProvider {
	private readonly consumedProjectList: ConsumedProjectListEntity;

	public constructor() {
		this.consumedProjectList = ConsumedProjectListEntity.build([
			{
				field: 'status',
				alias: $localize`:i18n=@@subscription.consumedProject.list.column.status:`,
				type: 'string',
				isSearchable: false,
				isFilterable: true,
				hasHeaderFilter: true,
				visibleIndex: 0,
			},
			{
				field: 'isInSync',
				alias: $localize`:i18n=@@subscription.consumedProject.list.column.isInSync:`,
				type: 'boolean',
				isSearchable: false,
				isFilterable: true,
				hasHeaderFilter: true,
				visibleIndex: 1,
			},
			{
				field: 'projectLabel',
				alias: $localize`:i18n=@@subscription.consumedProject.list.column.label:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				hasHeaderFilter: true,
				visibleIndex: 2,
			},
			{
				field: 'targetProjectVersions',
				alias: $localize`:i18n=@@subscription.consumedProject.list.column.targetProjectVersions:`,
				type: '',
				isSearchable: true,
				isFilterable: true,
				hasHeaderFilter: true,
				visibleIndex: 3,
			},
			{
				field: 'profileLabel',
				alias: $localize`:i18n=@@subscription.consumedProject.list.column.profileLabel:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				hasHeaderFilter: true,
				visibleIndex: 4,
			},
			{
				field: 'columnProfileCount',
				alias: $localize`:i18n=@@subscription.consumedProject.list.column.columns:`,
				type: '',
				isSearchable: true,
				isFilterable: true,
				hasHeaderFilter: false,
				visibleIndex: 5,
			},
			{
				field: 'sourceProjectVersion',
				alias: $localize`:i18n=@@subscription.consumedProject.list.column.sourceProjectVersion:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				hasHeaderFilter: true,
				visibleIndex: 6,
			},
			{
				field: 'startDate',
				alias: $localize`:i18n=@@subscription.consumedProject.list.column.startDate:`,
				type: 'date',
				hasHeaderFilter: false,
				isSearchable: false,
				isFilterable: false,
				visibleIndex: 7,
			},
		]);
	}

	public getList(): ConsumedProjectListEntity {
		return this.consumedProjectList;
	}

	public setListElements(
		elements: Map<string, ConsumedProjectItemEntity>
	): ConsumedProjectListEntity {
		return this.consumedProjectList.setElements(elements);
	}
}
